
import { defineComponent, ref, reactive, PropType, Ref, computed } from 'vue'
import { ElForm } from 'element-plus'
import JrDialog from '@/components/jr-parts/JrDialog.vue'
import JrButton from '@/components/jr-parts/JrButton.vue'
import JrTextarea from '@/components/jr-parts/JrTextarea.vue'
import GeneralAttachedFiles from '@/components/inputs/GeneralAttachedFiles.vue'
import JrFileInput from '@/components/jr-parts/JrFileInput.vue'
import BoundarySave from '@/components/actions/BoundarySave.vue'
import { boundaryEditRule } from '@/constants/rules'
import { RequestHeaderBoundaryDetailForm } from '@/types/forms'
import Message from '@/services/message'

export interface Comment {
  history_comment: string | null
}

type Mode = 'edit' | 'add'

/**
 * 境界立会 確認・変更理由入力ダイアログ
 */
export default defineComponent({
  name: 'BoundarySaveConfirmDialog',
  emits: ['update:modelValue', 'sent'],
  components: {
    JrDialog,
    JrButton,
    JrTextarea,
    BoundarySave,
  },
  props: {
    // 開閉状態
    modelValue: {
      type: Boolean,
      required: true,
    },
    mode: {
      type: String as PropType<Mode>,
      required: true,
    },
    requestHeader: {
      type: Object as PropType<RequestHeaderBoundaryDetailForm>,
      required: true,
    },
    // ファイルアップロードコンポーネントref
    fileRefs: {
      type: Array as PropType<Array<Ref<InstanceType<typeof JrFileInput>>>>,
      required: true,
    },
    // その他ファイルコンポーネント
    generalAttachedFilesRef: {
      type: Object as PropType<InstanceType<typeof GeneralAttachedFiles>>,
      required: false,
      default: null,
    },
  },
  setup(props, context) {
    const formRef = ref<InstanceType<typeof ElForm>>()

    const historyCommentForm = reactive<Comment>({
      history_comment: '',
    })

    const saveConfirmMessage = Message.codes.CONFIRM_SAVE

    const close = () => {
      if (formRef.value) {
        // バリテーションクリア
        formRef.value.clearValidate()
      }
      historyCommentForm.history_comment = ''
      context.emit('update:modelValue', false)
    }
    const update = (visible: boolean) => {
      context.emit('update:modelValue', visible)
    }

    const boundaryId = computed(() => {
      if (props.mode === 'add') {
        return null
      } else {
        return props.requestHeader.boundary.boundary_id
      }
    })

    if (boundaryId.value === null) {
      historyCommentForm.history_comment = '境界立会新規登録'
    }

    const sent = () => {
      context.emit('sent')
      close()
    }

    return {
      formRef,
      historyCommentForm,
      close,
      update,
      sent,
      rules: boundaryEditRule,
      boundaryId,
      saveConfirmMessage,
    }
  },
})
